module.exports = __webpack_public_path__ + "static/ms-d39c2434f7da8a950f0ebedccca37ee4.svg";